<template>
  <div class="up-down-buttons">
    <div :class="[isMax ? 'invalid' : 'valid']">
      <span @click="updateValue(stepValue)" class="fa-layers fa-fw">
        <font-awesome-icon :icon="['fas', 'circle']" inverse />
        <font-awesome-icon :icon="['far', 'caret-circle-up']" />
      </span>
    </div>
    <div :class="[isMin ? 'invalid' : 'valid']">
      <span @click="updateValue(-stepValue)" class="fa-layers fa-fw">
        <font-awesome-icon :icon="['fas', 'circle']" inverse />
        <font-awesome-icon :icon="['far', 'caret-circle-down']" />
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "EditorUpDownButtons",
  props: {
    value: {
      type: Number,
      required: true,
    },
    minValue: {
      type: Number,
    },
    maxValue: {
      type: Number,
    },
    stepValue: {
      type: Number,
      default: 1,
    },
  },
  methods: {
    updateValue: function (step) {
      const newValue = this.value + step;
      if (
        (this.minValue == undefined || newValue >= this.minValue) &&
        (this.maxValue == undefined || newValue <= this.maxValue)
      ) {
        this.$emit("input", newValue);
      }
    },
  },
  computed: {
    isMin: function () {
      return this.minValue != undefined && this.value === this.minValue;
    },
    isMax: function () {
      return this.maxValue != undefined && this.value === this.maxValue;
    },
  },
};
</script>

<style lang="less" scoped>
.up-down-buttons {
  color: black;
  font-size: 8mm;
  .fa-inverse {
    color: white;
  }
}
.valid span {
  cursor: pointer;
}
</style>
